import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, imageUrl } from "@/lib/api";
import { useChampionship } from "@/context/ChampionshipContext";
import { sanitizeHtml } from "@/lib/sanitize";

export default function InfoPage() {
  const { slug } = useParams();
  const { current } = useChampionship() || {};
  const [page, setPage] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!current?.id) return;
    setNotFound(false);
    setPage(null);
    api.get(`/championships/${current.id}/info-pages/${slug}`).then((r) => setPage(r.data)).catch(() => setNotFound(true));
  }, [slug, current?.id]);

  if (notFound) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-20 text-center">
        <h1 className="font-display text-4xl font-bold">Page not found</h1>
        <Link to="/" className="text-primary underline mt-4 inline-block">Back home</Link>
      </div>
    );
  }
  if (!page) return <div className="max-w-3xl mx-auto px-6 py-20">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 py-20" data-testid="info-page">
      <div className="text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
        {current?.year} — Information
      </div>
      <h1 className="font-display text-4xl md:text-6xl font-extrabold tracking-tighter mt-3">{page.title}</h1>
      {page.image_path && (
        <img src={imageUrl(page.image_path)} alt="" className="w-full mt-10 border border-border" />
      )}
      <div className="prose-woc mt-10" dangerouslySetInnerHTML={{ __html: page.content_html }} />
    </article>
  );
}
